import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import { workshops, ButtonAdapter, Content, Headline, LazyImageAdapter } from '@miro-site/components_utils';
import { Box, Section, Video, Desktop } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var WORKSHOPS_BG_COLORS = workshops.WORKSHOPS_BG_COLORS;
var SECTION_STYLES = {
  position: 'relative',
  overflow: 'hidden',
  height: [null, 830],
  marginBottom: [48, 88]
};
// * &::nth-child doesn't work 🤨
var Col = styled(Box).attrs({
  $py: [null, 0],
  $px: [null, 10]
}).withConfig({
  displayName: "HeroSecondLevel__Col",
  componentId: "sc-ksa1nx-0"
})(["", " ", ";"], function (_ref) {
  var _ref$$isFirstColumn = _ref.$isFirstColumn,
      $isFirstColumn = _ref$$isFirstColumn === void 0 ? true : _ref$$isFirstColumn;
  var FIRST_COLUMN_WIDTH = '41.66%';
  var SECOND_COLUMN_WIDTH = '58.34%';
  return $isFirstColumn ? css(["width:", ";flex:0 0 ", ";"], FIRST_COLUMN_WIDTH, FIRST_COLUMN_WIDTH) : css(["width:", ";flex:0 0 ", ";"], SECOND_COLUMN_WIDTH, SECOND_COLUMN_WIDTH);
}, function (_ref2) {
  var theme = _ref2.theme;
  return css(["", ""], theme.mq.small(css(["width:100%;flex:0 0 100%;"])));
});
var Row = styled(Box).attrs({
  $my: 0,
  $mx: [null, -10]
}).withConfig({
  displayName: "HeroSecondLevel__Row",
  componentId: "sc-ksa1nx-1"
})(["display:flex;flex-wrap:wrap;flex-direction:row;"]);
var VerticalContent = styled.div.withConfig({
  displayName: "HeroSecondLevel__VerticalContent",
  componentId: "sc-ksa1nx-2"
})(["height:100%;display:flex;flex-direction:column;justify-content:space-between;"]);
var AssetsContainer = styled(Box).attrs({
  $mt: [40, null],
  $mx: [-20, null],
  $mb: [0, null],
  $py: [39, null],
  $px: [20, null]
}).withConfig({
  displayName: "HeroSecondLevel__AssetsContainer",
  componentId: "sc-ksa1nx-3"
})(["position:relative;"]);
var ShapeContainer = styled(Box).attrs({
  $styles: {
    width: [null, 1120],
    position: ['relative', 'absolute'],
    left: [0, null],
    transform: ['translateX(0)', 'translateX(-50%)']
  }
}).withConfig({
  displayName: "HeroSecondLevel__ShapeContainer",
  componentId: "sc-ksa1nx-4"
})(["top:0;bottom:0;left:50%;"]);
var Shape = styled(Box).attrs({
  $styles: {
    width: [365, 990],
    left: ['50%', '33.33%'],
    marginLeft: [null, 10],
    transform: ['translateX(-50%)', 'none']
  }
}).withConfig({
  displayName: "HeroSecondLevel__Shape",
  componentId: "sc-ksa1nx-5"
})(["height:100%;position:absolute;top:0;"]);
var ImageContainer = styled(Box).attrs({
  $styles: {
    borderRadius: [4],
    width: [325, 800]
  }
}).withConfig({
  displayName: "HeroSecondLevel__ImageContainer",
  componentId: "sc-ksa1nx-6"
})(["height:auto;max-height:100%;display:block;position:relative;z-index:3;overflow:hidden;", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return css(["", " ", " ", " ", ""], theme.mq.small(css(["box-shadow:0 ", " ", " rgba(5,0,56,0.12);"], theme.multipliers.small(theme.spaces.sm), theme.multipliers.small(theme.spaces.lg))), theme.mq.mediumDown(css(["box-shadow:0 ", " ", " rgba(5,0,56,0.12);"], theme.multipliers.mediumDown(theme.spaces.sm), theme.multipliers.mediumDown(theme.spaces.lg))), theme.mq.mediumUp(css(["box-shadow:0 ", " ", " rgba(5,0,56,0.12);"], theme.multipliers.mediumUp(theme.spaces.sm), theme.multipliers.mediumUp(theme.spaces.lg))), theme.mq.large(css(["box-shadow:0 ", " ", " rgba(5,0,56,0.12);"], theme.multipliers.large(theme.spaces.sm), theme.multipliers.large(theme.spaces.lg))));
});
var VideoContainer = styled(Box).attrs(function (_ref4) {
  var theme = _ref4.theme;
  return {
    $styles: {
      borderRadius: [theme.spaces.xxs, theme.spaces.sm],
      width: [325, 800]
    }
  };
}).withConfig({
  displayName: "HeroSecondLevel__VideoContainer",
  componentId: "sc-ksa1nx-7"
})(["position:relative;overflow:hidden;"]);
var ButtonContainer = styled(Box).attrs(function (_ref5) {
  var theme = _ref5.theme;
  return {
    $mt: [theme.spaces.lg, theme.spaces.xl]
  };
}).withConfig({
  displayName: "HeroSecondLevel__ButtonContainer",
  componentId: "sc-ksa1nx-8"
})([""]);

var getHeadline = function getHeadline(headlineProps) {
  var background = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  Object.assign(headlineProps, {
    size: headlineProps.size || 'medium',
    tag: headlineProps.tag || 'h1',
    color: workshops.isHighContrastColor(background) ? 'white' : headlineProps.color,
    align: headlineProps.align || 'left'
  });
  return /*#__PURE__*/_jsx(Headline, _objectSpread({}, headlineProps));
};

var HeroSecondLevel = function HeroSecondLevel(_ref6) {
  var headline = _ref6.headline,
      _ref6$background = _ref6.background,
      background = _ref6$background === void 0 ? 'workshops-color-grey' : _ref6$background,
      button = _ref6.button,
      content = _ref6.content,
      shape = _ref6.shape,
      image = _ref6.image,
      video = _ref6.video;
  var ref = React.useRef(null);
  var shapeRef = React.useRef(null);
  var textColor = workshops.isHighContrastColor(background) ? 'white' : background == '' ? 'dark' : null;
  React.useEffect(function () {
    if (!ref.current || !shapeRef.current) {
      return;
    }

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: ref.current,
        scrub: true,
        start: '-100px top',
        end: 'bottom top'
      }
    });
    tl.fromTo(shapeRef.current, {
      y: 0
    }, {
      y: -70
    });
  }, [ref, shapeRef]);
  return /*#__PURE__*/_jsxs(Section, {
    "data-place": "Hero Section",
    ref: ref,
    $styles: SECTION_STYLES,
    $noPaddingTop: true,
    $noPaddingBottom: true,
    type: "large",
    background: WORKSHOPS_BG_COLORS[background],
    children: [/*#__PURE__*/_jsx(Box, {
      $styles: {
        maxWidth: [null, 1120],
        zIndex: 3,
        margin: 'auto',
        position: 'relative'
      },
      $pt: [40, 120],
      $pb: [20, 80],
      $px: [20, null],
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsxs(VerticalContent, {
            children: [/*#__PURE__*/_jsxs("div", {
              children: [(headline === null || headline === void 0 ? void 0 : headline.text) && getHeadline(headline), button &&
              /*#__PURE__*/
              // make the contextual space lg xl through theme
              _jsx(ButtonContainer, {
                children: /*#__PURE__*/_jsx(ButtonAdapter, _objectSpread(_objectSpread({}, button), {}, {
                  type: !background || background == 'workshops-color-grey' ? 'blue' : 'white'
                }))
              })]
            }), /*#__PURE__*/_jsx(Box, {
              $mt: [64, 48],
              children: content && /*#__PURE__*/_jsx(Content, _objectSpread(_objectSpread({}, content), {}, {
                color: textColor || content.color
              }))
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          $isFirstColumn: false,
          children: /*#__PURE__*/_jsxs(AssetsContainer, {
            children: [image && /*#__PURE__*/_jsx(ImageContainer, {
              children: /*#__PURE__*/_jsx(LazyImageAdapter, {
                assets: image
              })
            }), (shape === null || shape === void 0 ? void 0 : shape.mobile) && /*#__PURE__*/_jsx(Shape, {
              children: /*#__PURE__*/_jsx(LazyImageAdapter, {
                assets: {
                  mobile: shape.mobile
                }
              })
            }), video && /*#__PURE__*/_jsx(VideoContainer, {
              children: /*#__PURE__*/_jsx(Video, {
                id: video.id,
                thumbnail: video.thumbnail
              })
            })]
          })
        })]
      })
    }), (shape === null || shape === void 0 ? void 0 : shape.desktop) && /*#__PURE__*/_jsx(Desktop, {
      children: /*#__PURE__*/_jsx(ShapeContainer, {
        children: /*#__PURE__*/_jsx(Shape, {
          "data-testid": "shape-test-id",
          ref: shapeRef,
          children: /*#__PURE__*/_jsx(LazyImageAdapter, {
            assets: {
              desktop: shape.desktop
            }
          })
        })
      })
    })]
  });
};

export default HeroSecondLevel;